export default {
  name: 'marking--mcMovementLogs',
  apiService: 'shoes',
  apiPath: '/admin/mc_move_logs',
};